module.exports = require("./fr-CD.d.ts");